import moment from 'moment';

/** Today first, then within next N days, soonest first; drops past & beyond window. */
export const UPCOMING_CELEBRATION_DAYS = 7;

/**
 * @param {Array} list
 * @param {'dateOfBirth'|'dateOfJoining'} dateKey
 * @returns {Array} filtered & sorted items (same shape as input elements)
 */
export function filterAndSortCelebrations(list, dateKey) {
  if (!list?.length) return [];
  const start = moment().startOf('day');

  const withDays = list
    .map((item) => {
      const raw = item?.[dateKey];
      if (!raw) return null;
      const occ = moment(raw).clone().year(start.year()).startOf('day');
      const daysLeft = occ.diff(start, 'days');
      return { item, daysLeft };
    })
    .filter(Boolean)
    .filter(({ daysLeft }) => daysLeft >= 0 && daysLeft <= UPCOMING_CELEBRATION_DAYS);

  withDays.sort((a, b) => {
    if (a.daysLeft === 0 && b.daysLeft !== 0) return -1;
    if (b.daysLeft === 0 && a.daysLeft !== 0) return 1;
    if (a.daysLeft !== b.daysLeft) return a.daysLeft - b.daysLeft;
    const na = (a.item.name || '').toLowerCase();
    const nb = (b.item.name || '').toLowerCase();
    return na.localeCompare(nb);
  });

  return withDays.map(({ item }) => item);
}

/**
 * Like filterAndSortCelebrations, but keeps `daysLeft` metadata for UI.
 * @returns {Array<{ item: any, daysLeft: number }>}
 */
export function celebrationsWithDaysLeft(list, dateKey) {
  if (!list?.length) return [];
  const start = moment().startOf('day');

  const withDays = list
    .map((item) => {
      const raw = item?.[dateKey];
      if (!raw) return null;
      const occ = moment(raw).clone().year(start.year()).startOf('day');
      const daysLeft = occ.diff(start, 'days');
      return { item, daysLeft };
    })
    .filter(Boolean)
    .filter(({ daysLeft }) => daysLeft >= 0 && daysLeft <= UPCOMING_CELEBRATION_DAYS);

  withDays.sort((a, b) => {
    if (a.daysLeft === 0 && b.daysLeft !== 0) return -1;
    if (b.daysLeft === 0 && a.daysLeft !== 0) return 1;
    if (a.daysLeft !== b.daysLeft) return a.daysLeft - b.daysLeft;
    const na = (a.item.name || '').toLowerCase();
    const nb = (b.item.name || '').toLowerCase();
    return na.localeCompare(nb);
  });

  return withDays;
}
